export default __webpack_public_path__ + "static/image4-0922cb7de4c42796083c4a50ac5deb67.webp";